import s from "./Btn.module.scss"


export function Btn(props){
    return(
        <button onClick={props.onClick} className={s.btn}>
            {props.title}
        </button>
    )
}